import { useDroppable } from '@dnd-kit/core';
import React from 'react';
import { useSessionStorage } from 'react-use';
import { Link } from 'wouter';
import { useObserver, useObserverReturningStore } from '../../../CodesThatsGottaGoSomewhereElse';
import { Icon } from '../../../concepts/resources/Icon';
import { AppLocation } from '../../AppLocation';
import { useResolve } from '../../Container';
import { WorkspaceModel } from '../../dashboard/Models';
import { NavMenu } from './NavMenu';

const WorkspaceRootItem = ({ active }: { active: boolean }) => {

    const workspace = useResolve(WorkspaceModel);

    const { setNodeRef, over } = useDroppable({
        id: `workspace:${workspace.id}:nav`,
        data: {
            accepts: ['board'],
        },
    });

    const dropping = over?.id === `workspace:${workspace.id}:nav`;

    return <NavMenu.Item ref={setNodeRef} active={active} dropping={dropping}>
        <NavMenu.ItemIcon>
            <Icon src="deqo://icons/dash/boards" />
        </NavMenu.ItemIcon>
        <NavMenu.ItemLabel>
            Boards
        </NavMenu.ItemLabel>
    </NavMenu.Item>;
};

const WorkspaceFolderSubItem = ({ folder, active }: { folder: any, active: boolean }) => {

    const { setNodeRef, over } = useDroppable({
        id: `folder:${folder.id}:nav`,
        data: {
            accepts: ['board'],
        },
    });

    const dropping = over?.id === `folder:${folder.id}:nav`;

    return <NavMenu.SubItem ref={setNodeRef} active={active} dropping={dropping}>
        <NavMenu.ItemIcon>
            <NavMenu.ItemDisc />
        </NavMenu.ItemIcon>
        <NavMenu.ItemLabel>
            {folder.label}
        </NavMenu.ItemLabel>
    </NavMenu.SubItem>;
};

export const WorkspaceMenuBlock = () => {

    const location = useObserverReturningStore(useResolve(AppLocation));
    const workspace = useObserver(useResolve(WorkspaceModel));
    const [expanded, setExpandFolders] = useSessionStorage(`deqo/ui/nav/${workspace.id}/expand-folders`, false);
    const canExpand = workspace.folders.length > 8 && !expanded;
    const visibleFolders = canExpand ? workspace.folders.slice(0, 10) : workspace.folders;
    const expandCount = workspace.folders.length - visibleFolders.length;

    return <NavMenu>
        <Link to="/boards">
            <WorkspaceRootItem active={location.includes('boards')} />
        </Link>
        {!!visibleFolders.length &&
            <NavMenu.ItemGroup>
                {visibleFolders.map(x =>
                    <Link key={x.id} to={`/boards/${x.id}`}>
                        <WorkspaceFolderSubItem active={location.includes('boards', x.id)} folder={x} />
                    </Link>
                )}
                {canExpand &&
                    <NavMenu.SubItem onClick={() => setExpandFolders(true)}>
                        <NavMenu.ItemIcon>
                            <NavMenu.ItemDisc />
                        </NavMenu.ItemIcon>
                        <NavMenu.ItemLabel>
                            +{expandCount} more...
                        </NavMenu.ItemLabel>
                    </NavMenu.SubItem>
                }
            </NavMenu.ItemGroup>
        }

        {workspace.type === 'team' && <>
            <Link to="/tasks">
                <NavMenu.Item active={location.includes('view', 'tasks')}>
                    <NavMenu.ItemIcon>
                        <Icon src="deqo://icons/dash/actions@[1.1,1.1,0]" />
                    </NavMenu.ItemIcon>
                    <NavMenu.ItemLabel>
                        Action Items
                    </NavMenu.ItemLabel>
                </NavMenu.Item>
            </Link>
            <Link to="/members">
                <NavMenu.Item active={location.includes('view', 'members')}>
                    <NavMenu.ItemIcon>
                        <Icon src="deqo://icons/dash/members" />
                    </NavMenu.ItemIcon>
                    <NavMenu.ItemLabel>
                        Members
                    </NavMenu.ItemLabel>
                </NavMenu.Item>
            </Link>
        </>}
    </NavMenu>;
};

